module.exports = __webpack_public_path__ + "static/media/Roboticon01@2x.0a147412.png";